import packageJson from "../package.json"

const envVersion =
  process.env.REACT_APP_RELEASE_NUMBER ||
  process.env.REACT_APP_RELEASE ||
  process.env.REACT_APP_BUILD_VERSION ||
  process.env.REACT_APP_BUILD_NUMBER ||
  process.env.REACT_APP_VERSION

const buildNumber = process.env.REACT_APP_BUILD_NUMBER || process.env.REACT_APP_BUILD

export const appVersion = envVersion || packageJson.version
export const appVersionLabel =
  buildNumber && buildNumber !== appVersion ? `${appVersion} (build ${buildNumber})` : appVersion
